
import { createApiClient } from 'Network/ApiClient';

export const CustomIcdAxiosInstance = createApiClient('customicd/');


